import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import NavItemPositionModalButton from "../../visComponents/navigation/navItemPositionModalButton";
import {featureInterface} from "../../../interfaces/featureInterface";
import {getPositionsArray} from "../../visComponents/navigation/navItemPositionModal";


const FeatureInfoAssociatedProductShelfOptions = (props) => {

  const {activeFeature, parentOptionClick} = props;

  if (!activeFeature) {
    return null
  }

  const featureGroup = activeFeature.getParent();
  const positionsArray = getPositionsArray(activeFeature.partId).filter(pos => {
    return featureGroup && featureGroup.getMatchingPositionFeature(pos, activeFeature);
  });

  return (
    <div className="block">
      <div className="block">
        <div className="inline-block margin-t-8">
        <span className="nav-pos__title bold block">
          Left:
        </span>
          <div className="flex flex--start margin-t-8">
            {positionsArray.slice(0, 3).map((shelf, shelfIndex) => {
              return (
                <div className={shelfIndex ? "margin-l-16" : ""} key={shelfIndex}>
                  <NavItemPositionModalButton position={shelf}
                                              parent={featureGroup}
                                              activeFeature={activeFeature}/>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      {positionsArray.length > 3 ? (
        <div className="block">
          <div className="inline-block margin-t-8">
            <span className="nav-pos__title bold block">
              Right:
            </span>
            <div className="flex flex--start margin-t-8">
              {positionsArray.slice(3, 6).map((shelf, shelfIndex) => {
                return (
                  <div className={shelfIndex ? "margin-l-16" : ""} key={shelfIndex}>
                    <NavItemPositionModalButton position={shelf}
                                                updateCheckboxes={parentOptionClick}
                                                parent={featureGroup}
                                                activeFeature={activeFeature}/>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
};

FeatureInfoAssociatedProductShelfOptions.propTypes = {
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {canvasCount} = store.bathroomVisualizerState;
  return {
    canvasCount,
  };
};

export default connect(mapStateToProps)(FeatureInfoAssociatedProductShelfOptions)
